export default {
  computed: {
    localeLanguage() {
         return this.$store.getters.getLanguage
    }
  },
  methods: {
    serverTranslate(statement) {
      if (!statement) return statement;
      const lang = this.localeLanguage || localStorage.getItem("lang")
      if (lang === "ar") {
        statement =
          statement && statement.indexOf("|") >= 0
            ? statement.split("|")[0] || statement.split("|")[1]
            : statement;
        return statement;
      } else {
        statement =
          statement && statement.indexOf("|") >= 0
            ? statement.split("|")[1] || statement.split("|")[0]
            : statement;
        return statement;
      }
    },
    serverTranslateArray: function(data, key) {
      let translatedArray = [{}];
      translatedArray.pop();
      let filterdData = [{}];
      translatedArray = JSON.parse(JSON.stringify(data));
      filterdData = translatedArray.map(item => {
        item[key] = this.serverTranslate(item[key]);
        if (item["children"]) {
          item["children"].map(item => {
            item[key] = this.serverTranslate(item[key]);
            if (item["children"]) {
              item["children"].map(item => {
                item[key] = this.serverTranslate(item[key]);
              });
            }
          });
        }
        return item;
      });
      return filterdData;
   },
   serverTranslateArrayKeys: function(data, keys) {
     let translatedArray = [{}];
     translatedArray.pop();
     let filterdData = [{}];
     translatedArray = JSON.parse(JSON.stringify(data));
     filterdData = translatedArray.map(item => {
        for (var i = 0; i < keys.length; i++) {
           item[keys[i]] = this.serverTranslate(item[keys[i]])
        }
        return item
     });
     return filterdData;
   }
  }
};
